import moment from "moment";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { showValidation } from "./utilities/showValidation";
import { showLabel } from "./utilities/showLabel";

const TimePickerField = (props) => {
  let { formId, field } = props;
  let { element } = field;

  const { showTimeInput } = element.settings[element.type];
  const additionalClass = "hide-drop-down";

  return (
    <div className={`field-style ${showTimeInput ? additionalClass : ""}`}>
      {showLabel(field, formId)}
      <DatePicker
        placeholderText={element.placeholder.visible ? element.placeholder.value.toUpperCase() : ""}
        id={formId + "_" + field.id}
        name={formId + "_" + field.id}
        selected={element.value && Date.parse(element.value) ? moment(element.value) : null}
        disabled={element.disabled}
        onChange={(date) => props.changeHandler({ target: { value: date } }, false)}
        showTimeSelect={!showTimeInput}
        showTimeInput={showTimeInput}
        showTimeSelectOnly
        timeIntervals={element.settings[element.type].timeIntervals}
        dateFormat={element.settings[element.type].format}
        timeFormat={element.settings[element.type].format}
        minTime={element.settings[element.type].minTime}
        maxTime={element.settings[element.type].maxTime}
      />
      {showValidation(field)}
    </div>
  );
};

export default TimePickerField;



// WEBPACK FOOTER //
// ./src/libraries/form/formField/fields/TimePickerField.jsx